import { render, staticRenderFns } from "./config-task-value.vue?vue&type=template&id=51123698&"
import script from "./config-task-value.vue?vue&type=script&lang=js&"
export * from "./config-task-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51123698')) {
      api.createRecord('51123698', component.options)
    } else {
      api.reload('51123698', component.options)
    }
    module.hot.accept("./config-task-value.vue?vue&type=template&id=51123698&", function () {
      api.rerender('51123698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/config-task-value.vue"
export default component.exports